import { compareStrings } from "./viewModelMethods";

export const getSignatoryRoleLabel = (eligibleSigners: string) => {
  if (eligibleSigners !== undefined)
    return eligibleSigners.split(", \n").join(" / ");
};

export const getFacilityRole = (roles: any[], facility: string) => {
  return roles.find((role) => role.facilityId === facility);
};

export const hasUserSigned = (signatories: any[], loggedInUserId: string) => {
  return signatories.some(
    (signatory) => signatory.Contact_on_Facility__c === loggedInUserId
  );
};

export const disableSignatoryButton = (
  signatureData: any,
  userRole: string
) => {
  let isUserBlocked = true;
  if (signatureData.Eligible_Signers__c !== undefined) {
    let sigString = signatureData.Eligible_Signers__c;
    let eChars = ["\n", "\r"];
    for (const eChar of eChars) {
      sigString = sigString.replaceAll(eChar, "");
    }
    const eligibleSigners = sigString
      ? sigString.split(",")
      : [];
    isUserBlocked = userRole
      ? !eligibleSigners.some((signer: string) =>
        compareStrings(signer, userRole)
      )
      : true;
  }
  return !!signatureData.Contact_on_Facility__c || isUserBlocked;
};

export const disableUpdateButton = (
  signatureData: any,
  loggedInUserId: string
) => {
  return signatureData.Contact_on_Facility__c !== loggedInUserId;
};

interface IsSignatoryApprovableOpts {
  isQAPILevel?: boolean;
  isQAPIDisabled?: boolean;
  userSignedOff: boolean;
  isActionLoading: boolean;
  isConclusionFilled: boolean;
  isStatusValid: boolean;
}

/**
 * Single source of truth for whether a signatory row's Approve button is enabled.
 * Used by both the ApprovalList row buttons and the MarkReadyConfirmModal approve path.
 */
export const isSignatoryApprovable = (
  signatory: any,
  userRole: string,
  opts: IsSignatoryApprovableOpts
): boolean => {
  if (signatory?.Status__c) return false;
  const { isQAPILevel, isQAPIDisabled, userSignedOff, isActionLoading, isConclusionFilled, isStatusValid } = opts;
  const isDisabled =
    (isQAPILevel ? !!isQAPIDisabled : false) ||
    userSignedOff ||
    isActionLoading ||
    !isConclusionFilled ||
    !isStatusValid;
  return !isDisabled && !disableSignatoryButton(signatory, userRole);
};
